import { render } from "./FeatherIconPage.vue?vue&type=template&id=1a2fddf2&ts=true"
import script from "./FeatherIconPage.vue?vue&type=script&lang=ts"
export * from "./FeatherIconPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__